import testProctoringResourceActions from '@resources/test-proctoring/actions';
import testResourceActions from '@resources/tests/actions';

import { clearCache } from '@util/cache';
import { TEST_ROUTE, TEST_PROCTORING_ROUTE } from '@routes';

const cacheRemove = () => next => action => {
  switch (action.type) {
    case 'CLEAR_GOALS':
    case testResourceActions.RELOAD_BY_ID.type:
      clearCache(TEST_ROUTE);
      next(action);
      break;
    case testProctoringResourceActions.LOAD_STATUS.type:
    case testProctoringResourceActions.LOAD_STATUS_UPDATE.type:
    case testProctoringResourceActions.LOAD_STATUS_BY_TEST_SECTIONS.type:
    case testProctoringResourceActions.LOAD_TEST_ENTRIES_BY_SECTION_AND_TEST.type:
      clearCache(TEST_PROCTORING_ROUTE);
      next(action);
      break;

    default:
      next(action);
  }
};

export default cacheRemove;
